import styled from "styled-components";
import { colors2 } from "oolib";

// Building blocks shared by the integration popups (see modals/).

export const Card = styled.div`
  border: 1px solid ${colors2.grey10};
  border-radius: 12px;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid ${colors2.grey10};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid ${colors2.grey5};
  &:last-child {
    border-bottom: none;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// Schedule label at rest, actions on hover.
export const DatasetRow = styled(Row)`
  .rowActions {
    display: none;
  }
  &:hover {
    padding: 5px 14px;
    background: ${colors2.grey5};
    .rowActions {
      display: flex;
    }
    .rowSchedule {
      display: none;
    }
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: ${colors2.grey80};
  cursor: pointer;
  &:hover {
    background: ${colors2.grey10};
  }
  &:disabled {
    opacity: 0.4;
    cursor: default;
    background: transparent;
  }
`;

// DisplayIcon forces cursor: default on its wrapper when it has no onClick of
// its own; inherit lets the surrounding button's pointer show through.
export const INHERIT_CURSOR = { cursor: "inherit" };

export const Divider = styled.span`
  width: 1px;
  height: 20px;
  background: ${colors2.grey10};
`;

export const EditToggle = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 14px;
  border: none;
  border-bottom: ${({ $open }) => ($open ? `1px solid ${colors2.grey10}` : "none")};
  background: transparent;
  cursor: pointer;
`;

export const EditBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px;
`;

export const redOutline = {
  color: colors2.red,
  boxShadow: `inset 0 0 0 1px ${colors2.red}`,
};
